import api from '@/services/api'

export default {
  state: {},

  mutations: {},

  actions: {
    async sendWhatsApp({ commit }, data) {
      try {
        const url = `/periods/${data.periodId}/unity/${data.unityId}/send-whatsapp`
        return await api.post(url, data.customers)
      } catch (error) {
        throw error
      }
    },
  },

  getters: {},
}
